<template>
  <div class="border pad-10" :class="{ 'border-active': selected, 'hover-pointer': !selected }" @click.prevent="select">
    <div class="text-right">
      <!-- Really funky markup from OneUI -->
      <label class="css-input css-checkbox css-checkbox-rounded css-checkbox-primary">
        <input :checked="selected" type="checkbox" class="display-none" :aria-labelledby="labelIDs">
        <span></span>
      </label>
    </div>

    <slot></slot>
  </div>
</template>

<script lang="ts">
  
  import { Component, Prop, Watch, Emit, Vue } from 'vue-facing-decorator';
  @Component
  export default class RadioTile extends Vue {
    @Prop({ required: true, type: String }) modelValue!: string;
    @Prop({ required: true, type: String }) inputVal!: string;
    @Prop({ type: String }) labelIDs!: string;

    selected = false;
    
    @Watch('modelValue')
    onValueChanged(newValue: string, oldValue: string) {
      if (newValue != oldValue) {
        this.selected = newValue == this.inputVal;
      }
    }

    @Emit("update:modelValue")
    modelInput(): string {
      return this.inputVal;
    }

    @Emit("input")
    input() {
      this.modelInput();
      return this.inputVal;
    }

    created() {
      this.selected = this.modelValue == this.inputVal;
    }

    select() {
      if (this.selected) { return; }
      this.input();
    }
  }
</script>
